
import React from "react";
import { Investor } from "@/types/investor";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { ExternalLink } from "lucide-react";
import { hookDebugUtils } from "@/utils/ai/debugUtils";

interface InvestorSourcesDialogProps {
  investor: Investor | null;
  onClose: () => void;
}

const InvestorSourcesDialog = ({ investor, onClose }: InvestorSourcesDialogProps) => {
  // Safe render helper to prevent rendering objects directly
  const safeRender = (value: any): string => {
    if (value === null || value === undefined) return "";
    if (typeof value === 'string') return value;
    if (typeof value === 'number') return value.toString();
    if (typeof value === 'boolean') return value.toString();
    return hookDebugUtils.safeObjectDisplay(value) || "";
  };

  return (
    <Dialog open={!!investor} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogTitle>Sources for {investor?.firm}</DialogTitle>
        <div className="max-h-96 overflow-y-auto">
          {investor?.sources?.map((source, index) => (
            <div key={index} className="py-2 border-b last:border-0">
              <div className="flex items-start gap-2">
                <span className="font-bold">{index + 1}.</span>
                <a 
                  href={source} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-blue-600 hover:underline break-all flex items-center gap-1"
                >
                  {safeRender(source)}
                  <ExternalLink size={14} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default InvestorSourcesDialog;
